export default __webpack_public_path__ + "a4f61e738864cbedf5d222c889f9828b.gif";